import { I18n } from "react-i18nify";
import store from "../store";
import log from "../utils/log";
import errorUtils from "../utils/errorUtils";
import {
	requestLogin,
	loginSuccess,
	loginFail,
	requestLogout,
	logoutSuccess,
	logoutFail
} from "../actions/loginActions";
import loginDao from "./loginDao";
import { appFlushDatas } from "../actions/appActions";

const loginApi = {
	login(username, password, env) {
		log.log("[loginApi.login] START, username %s, password %s", username, password);
		console.warn("LOGIN FROM LOGIN API")
		store.dispatch(requestLogin());

		let loginDaoCall = loginDao.login(username, password, env);

		loginDaoCall
			.then(function(res) {
				store.dispatch(loginSuccess(res.token));
				log.log("[loginApi.login] END");
			})
			.catch(function(err) {
				store.dispatch(loginFail());
				errorUtils.dispatchErrorWithTimeout(I18n.t("errorMessage.loginFail"));
				log.log(err);
			});
		return loginDaoCall;
	},
	logout(sessionToken) {
		log.log("[loginApi.logout] START");

		store.dispatch(requestLogout());

		let loginDaoCall = loginDao.logout(sessionToken);

		loginDaoCall
			.then(function(res) {
				store.dispatch(logoutSuccess());
				store.dispatch(appFlushDatas());
				log.log("[loginApi.logout] END");
			})
			.catch(function(err) {
				store.dispatch(logoutFail());
				log.log(err);
			});
		return loginDaoCall;
	}
};

export default loginApi;



// WEBPACK FOOTER //
// ./src/api/loginApi.js